
package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
actual data class AuthResponse(
    actual var success: Boolean? = null,
    actual var errorMessage : String? = null,
    actual var successMessage : String? = null,
    actual var userInfo: UserInfo? = null,
)